import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router';
import styled, { createGlobalStyle } from 'styled-components';
import { Popup } from '../utils/popups';
import { Helmet } from './Helmet';
export function Layout() {
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, {}), _jsx(GlobalStyle, {}), _jsxs(LayoutRoot, { children: [_jsx("main", { children: _jsx(Outlet, {}) }), _jsx(Footer, {})] }), _jsx(Container, {})] }));
}
const Container = styled(Popup.Container) `
    height: 100%;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
`;
const GlobalStyle = createGlobalStyle `
    html, body {
        background: var(--Layout_Background, url('background.jpg'));
        background-attachment: fixed;
        background-size: cover;
        overscroll-behavior: none;
    }

    body {
        font-family: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif;
        font-size: 16px;
        line-height: 2em;
        -webkit-overflow-scrolling: touch;
    }
`;
const Footer = styled.footer `
    position: fixed;
    bottom: 1rem;
    right: 1rem;
`;
const LayoutRoot = styled.div `
`;
